import { useEffect } from 'react';

import { useBreakPoints } from 'core';
import { Modal, ScrollArea, Stack, Text } from 'ui';
import { useDisclosure } from 'ui/Hooks';

import styles from './OnboardingModal.module.css';

// TODO: (FTUX) Replace with OnboardingModal from core @Dylan-Brandenburg
export const OnboardingModal = ({
  children,
  title,
  description,
}: {
  children: React.ReactNode;
  title: string;
  description: string;
}) => {
  const { isSmallScreen } = useBreakPoints();
  const [isOpen, { open }] = useDisclosure(false);

  useEffect(() => {
    open();
    // eslint-disable-next-line react-hooks/exhaustive-deps -- only set to open on mount to ensure there is a transition
  }, []);

  return (
    <Modal
      opened={isOpen}
      onClose={() => {}}
      withCloseButton={false}
      fullScreen={isSmallScreen}
      title={
        <Stack c="white" gap="xs">
          <Text fz="24" fw="600">
            {title}
          </Text>
          <Text fz="16" fw="500">
            {description}
          </Text>
        </Stack>
      }
      classNames={{
        header: styles.onboardingModalHeader,
        body: styles.onboardingModalBody,
      }}
      size="lg"
      scrollAreaComponent={ScrollArea.Autosize}
    >
      {children}
    </Modal>
  );
};
